import React from 'react';
import { useGameState } from './GameStateContext';
import AxeImage from './Axe.png';
import MetalAxeImage from '/Users/boom/chop/src/MetalAxe.png'; // Ensure the path is correct

const Inventory = () => {
    const { inventory, setEquippedAxe } = useGameState();

    const selectAxe = (axe) => {
        setEquippedAxe(axe);
        // Additional logic for updating the game state with the selected axe
    };

    return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <h2>Inventory</h2>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                {inventory.map((item, index) => (
                    <div key={index} style={{ margin: '10px', textAlign: 'center' }}>
                        <img 
                            src={item.type === 'Metal' ? MetalAxeImage : AxeImage} 
                            alt={`${item.type} Axe`} 
                            style={{ width: '100px', height: '100px', cursor: 'pointer' }}
                            onClick={() => selectAxe(item)}
                        />
                        <p>{item.type} Axe</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Inventory;
